import React, { useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import {
  AGE_GROUP_OPTIONS,
  REGION_OPTIONS,
  VACCINE_OPTIONS,
} from '../../app/config';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import Title from '../../components/Title';
import api from '../../app/api';
import Tooltip from '../../components/Tooltip';

const StyledContent = styled.nav`
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
`;
const Label = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-bottom: 0.5em;
`;
const Counter = styled.span`
  border-radius: 50%;
  color: var(--white);
  background: var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-weight: bold;
  font-size: large;
  margin-right: 0.5em;
`;
const Steps = styled.div`
  width: 40%;
  margin: 0 auto;
  @media (max-width: 900px) {
    width: 65%;
  }
  @media (max-width: 576px) {
    width: 95%;
  }
`;
const Step = styled.div`
  margin-bottom: 2em;
`;
const Result = styled.div`
  font-weight: bold;
  margin: 1em 0;
  font-size: 1.5rem;
  text-align: center;
  color: var(--success);
  position: relative;
  @media (max-width: 576px) {
    margin: 1em;
  }
  span {
    color: var(--black);
  }
`;
export const Emoji = styled.span`
  font-weight: 100;
`;

function CalculatorForm() {
  const [region, setRegion] = useState();
  const [ageGroup, setAgeGroup] = useState();
  const [vaccine, setVaccine] = useState(VACCINE_OPTIONS[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [result, setResult] = useState();

  const isSubmitDisabled = isLoading || !region || !ageGroup || !vaccine;

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (!isSubmitDisabled) {
        setIsLoading(true);
        setError(false);

        const { data } = await api.post('calculator', {
          region: region.value,
          ageGroup: ageGroup.value,
          vaccine: vaccine.value,
        });
        setResult({ from: data.from, to: data.to });
      }
    } catch (e) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledContent>
      <Title>
        Zistite koľko ľudí je pred vami v čakárni na vakcínu proti Covid-19 (1.
        dávka)! <Emoji>🧐</Emoji>
      </Title>
      <br />
      <Steps>
        <Step>
          <Label>
            <Counter>1.</Counter>{' '}
            <label htmlFor="region">Vyberte váš kraj</label>
          </Label>
          <Select
            inputId="region"
            value={region}
            onChange={setRegion}
            options={REGION_OPTIONS}
            placeholder={''}
          />
        </Step>
        <Step>
          <Label>
            <Counter>2.</Counter>{' '}
            <label htmlFor="age">Vyberte vašu vekovú skupinu</label>
          </Label>
          <Select
            inputId="age"
            value={ageGroup}
            onChange={setAgeGroup}
            options={AGE_GROUP_OPTIONS}
            placeholder={''}
          />
        </Step>
        <Step>
          <Label>
            <Counter>3.</Counter>{' '}
            <label htmlFor="vaccine">Vyberte vašu vakcínu</label>
          </Label>
          <Select
            inputId="vaccine"
            value={vaccine}
            onChange={setVaccine}
            options={VACCINE_OPTIONS}
            placeholder={''}
          />
        </Step>
        <Step>
          <Button big disabled={isSubmitDisabled} onClick={handleSubmit}>
            Vyhodnotiť!
          </Button>
        </Step>
        {isLoading && <Loader />}
        {error && <Error />}
        {Boolean(result && typeof result === 'object') && (
          <Result>
            Gratulujeme! Na základe posledných dát sa pred vami nachádza{' '}
            <span>{result.from}</span> ľudí <Emoji>🎉</Emoji>
            {result.to !== result.from && (
              <Tooltip
                title={`${result.from} ľudí sa nachádza pred vami a ${
                  result.to - result.from
                } je vo vašej vekovej skupine`}
                style={{ position: 'absolute', right: '-25px', top: '-10px' }}
              >
                ?
              </Tooltip>
            )}
          </Result>
        )}
      </Steps>
    </StyledContent>
  );
}

export default CalculatorForm;
